import {
  Box,
  Button,
  Divider,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  Input,
  Stack,
  Tag,
  TagCloseButton,
  TagLabel,
  Text,
} from "@chakra-ui/core";
import React, { useState } from "react";
import CardFooter from "../CardFooter";

const primSkillData = [
  "UX UI",
  "App Design",
  "Print Design",
  "UI Design",
  "lorem ipsum",
];
const secSkillData = [
  "UX UI",
  "App Design",
  "Print Design",
  "UI Design",
  "lorem ipsum",
];

const SkillChip = ({ label, isClosable, index, deleteSkill }) => (
  <Tag
    margin="1em"
    size="lg"
    rounded="full"
    variant="solid"
    color="black"
    variantColor="cyan"
  >
    <TagLabel>{label}</TagLabel>
    {isClosable && <TagCloseButton onClick={() => deleteSkill(index)} />}
  </Tag>
);

function Skills() {
  const [secSkill, setSecSkill] = useState(secSkillData);
  const [skillInp, setSkillInp] = useState("");
  const [helperText, setHT] = useState("");
  const deleteSkill = (index) => {
    setSecSkill(secSkill.filter((each) => each !== secSkill[index]));
  };
  const handleSkill = (value) => {
    if (!secSkill.includes(value)) {
      setSecSkill([...secSkill, value]);
      setSkillInp("");
      setHT("");
    } else {
      setHT(`${value} already exists`);
      setSkillInp("");
    }
  };
  return (
    <Box p="10">
      <Text fontSize="2xl">Add Skills</Text>
      <Divider marginBottom="2em" />
      <Stack>
        <FormControl>
          <FormLabel>Primary Skills</FormLabel>
          {/* <Input placeholder="Web Designing" /> */}
          {/* <SimpleGrid minChildWidth="130px" spacing="0.5em"> */}
          <Box>
            {primSkillData.map((each) => (
              <SkillChip label={each} key={each} />
            ))}
          </Box>
          {/* </SimpleGrid> */}
        </FormControl>
        <FormControl isInvalid={helperText}>
          <FormLabel>Secondary Skills</FormLabel>
          <Stack isInline>
            <Input
              value={skillInp}
              onChange={(e) => setSkillInp(e.target.value)}
              placeholder="Web Designing"
            />
            <Button onClick={() => handleSkill(skillInp)}>
              <Icon name="add" />
            </Button>
          </Stack>

          {helperText && <FormErrorMessage>{helperText}</FormErrorMessage>}

          {secSkill.map((each, index) => (
            <SkillChip
              index={index}
              deleteSkill={deleteSkill}
              isClosable
              label={each}
              key={each}
            />
          ))}
        </FormControl>
      </Stack>
      <CardFooter />
    </Box>
  );
}

export default Skills;
